import { jsx as a, jsxs as b } from "react/jsx-runtime";
import { createContext as $, useContext as j, useRef as R, useState as x, useLayoutEffect as B, useEffect as D, Fragment as q } from "react";
import { c as p } from "./tw-cn-mXgPecoF.mjs";
import { c as z } from "./variance-DhhqoHkK.mjs";
import { e as N } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { D as F } from "./divider-CwxAn95O.mjs";
const k = $(null), M = z("", {
  variants: {
    size: {
      large: "min-h-44 rounded-12",
      medium: "min-h-40 rounded-8"
    },
    pcSize: {
      large: "pc:min-h-44 pc:rounded-12",
      medium: "pc:min-h-40 pc:rounded-8"
    }
  },
  defaultVariants: {
    size: "medium",
    pcSize: "large"
  }
}), A = z("w-auto relative flex items-center p-3 border border-line-neutral-weak3", {
  variants: {
    size: {
      large: "rounded-16",
      medium: "rounded-12"
    },
    pcSize: {
      large: "pc:rounded-16",
      medium: "pc:rounded-12"
    },
    hasError: {
      true: "border-line-danger-main",
      false: "border-line-neutral-weak3"
    }
  }
}), G = ({
  size: r,
  pcSize: t,
  isSelected: n
}) => {
  const o = {
    large: n ? "typography-subtitle-16-bold text-text-primary-main" : "typography-subtitle-16-regular",
    medium: n ? "typography-body-14-bold text-text-primary-main" : "typography-body-14-regular"
  };
  return p(o[r], `pc:${o[t]}`);
}, H = z("pointer-events-none absolute border border-fill-primary-main", {
  variants: {
    size: {
      large: "rounded-12",
      medium: "rounded-8"
    },
    pcSize: {
      large: "pc:rounded-12",
      medium: "pc:rounded-8"
    }
  }
}), J = ({
  label: r,
  value: t,
  className: n = "",
  size: o,
  disabled: s
}) => {
  const i = N({
    property: o,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "medium", pc: "large" }
  }), l = j(k);
  if (!l) throw new Error("SegmentedControlOption must be used inside SegmentedControl");
  const { selectedValue: u, onSelect: c } = l, g = u === t, m = M({ ...i }), f = (y) => {
    y.preventDefault(), !s && c(t);
  };
  return /* @__PURE__ */ a(
    "li",
    {
      className: p(
        "flex w-auto flex-1 items-center justify-center",
        {
          "pointer-events-none cursor-not-allowed bg-fill-neutral-weak": s
        },
        m,
        n
      ),
      "data-segment-value": t,
      role: "presentation",
      children: /* @__PURE__ */ a(
        "button",
        {
          className: p(
            "w-full p-4 disabled:text-interaction-neutral-disable-main hover-never:border-transparent hover-never:bg-interaction-neutral-presshover-weak1",
            m,
            G({ size: i.size, pcSize: i.pcSize, isSelected: g })
          ),
          disabled: s,
          onClick: f,
          role: "tab",
          type: "button",
          children: r
        }
      )
    }
  );
}, ee = ({
  options: r,
  value: t,
  onChange: n,
  className: o = "",
  size: s,
  segmentClassName: i,
  hasError: l = !1,
  errorMessage: u = ""
}) => {
  const c = R(null), [g, m] = x(!1), [f, y] = x({
    transform: "translate(0px, 0px)",
    width: 0,
    height: 0,
    opacity: 0
  }), [E, v] = x(!1), h = R(), C = N({
    property: s,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "medium", pc: "large" }
  }), T = A({ ...C, hasError: l }), V = H({ ...C }), I = () => {
    const e = c.current;
    return e ? e.querySelector(`[data-segment-value="${String(t)}"]`) : null;
  }, w = () => {
    const e = c.current, d = I();
    if (!e || !d) return;
    const O = e.getBoundingClientRect(), S = d.getBoundingClientRect(), P = S.left - O.left + e.scrollLeft - 1;
    y({
      transform: `translate(${P}px, 3px)`,
      width: S.width,
      height: S.height,
      opacity: 1
    });
  };
  B(() => {
    w();
  }, [t, r]), D(() => {
    m(!0);
    const e = () => {
      v(!0), w(), clearTimeout(h.current), h.current = setTimeout(() => {
        v(!1);
      }, 100);
    };
    return window.addEventListener("resize", e), () => {
      window.removeEventListener("resize", e), clearTimeout(h.current);
    };
  }, [t, r]);
  const K = r.findIndex((e) => e.value === t), L = r.length - 1;
  return /* @__PURE__ */ b(k.Provider, { value: { selectedValue: t, onSelect: n }, children: [
    /* @__PURE__ */ b("ul", { className: p(T, o), ref: c, role: "tablist", children: [
      /* @__PURE__ */ a(
        "div",
        {
          "aria-hidden": !0,
          className: V,
          style: {
            left: 0,
            top: 0,
            ...f,
            // resizing 여부와 관계없이 transition을 적용하면 리사이징 중에 테두리가 출렁거리는 현상 발생
            transition: g && !E ? "transform 300ms ease-out, opacity 300ms ease-out" : "none"
          }
        }
      ),
      r.map((e, d) => /* @__PURE__ */ b(q, { children: [
        /* @__PURE__ */ a(J, { className: i, size: s, ...e }),
        d !== L && d !== K - 1 && /* @__PURE__ */ a(F, { className: "h-16 w-1" })
      ] }, e.value))
    ] }),
    l && u ? /* @__PURE__ */ a("p", { className: "mt-8 px-4 text-text-danger-main typography-body-12-regular", children: u }) : null
  ] });
};
export {
  k as S,
  J as a,
  ee as b
};
